export default "__VITE_ASSET__CDuByNdL__"